import { accessRole } from "../../../helpers/access_role";
import ErrorAccess from "../../../components/Error/Content/Access";

import IndexView from "./Index/View";
// import CreateView from "./Create/View";
import DetailView from "./Detail/View";

const RouteView = (props) => {
  const queryParams = new URLSearchParams(props.location.search);
  const _uuid = queryParams.get("uuid");
  //   const _create = queryParams.get("create");
  const _detail = queryParams.get("detail");

  //   if (_create != null) {
  //     return accessRole("create") ? <CreateView /> : <ErrorAccess />;
  if (_detail != null) {
    return accessRole("read") ? <DetailView /> : <ErrorAccess />;
  }
  return accessRole("read") ? <IndexView /> : <ErrorAccess />;
};
export default RouteView;
